import { createLayerContainer } from '@antv/l7-core';
import { DOM } from '@antv/l7-utils';
import { updateLayersConfig } from "./style/utils";
export var tileVectorParser = ['mvt', 'geojsonvt', 'testTile'];
/**
 * 判断当前图层是否是瓦片图层
 * @param layer
 * @returns
 */

export function isTileGroup(layer) {
  var source = layer.getSource();
  return tileVectorParser.includes(source.parser.type);
}
export function isVectorTile(parserType) {
  return tileVectorParser.indexOf(parserType) >= 0;
}
export function registerLayers(parentLayer, layers) {
  layers.map(function (layer) {
    var container = createLayerContainer(parentLayer.sceneContainer);
    layer.setContainer(container, parentLayer.sceneContainer);
    layer.init();
  });
}
export function getLayerShape(layerType, layer) {
  var _layerShape$scale;

  var layerShape = layer.getAttribute('shape');

  if (layerShape && (_layerShape$scale = layerShape.scale) !== null && _layerShape$scale !== void 0 && _layerShape$scale.field) {
    var _layerShape$scale2;

    if (((_layerShape$scale2 = layerShape.scale) === null || _layerShape$scale2 === void 0 ? void 0 : _layerShape$scale2.values) === 'text') {
      return [layerShape.scale.field, layerShape.scale.values];
    }

    return layerShape.scale.field;
  }

  switch (layerType) {
    case 'PolygonLayer':
      return 'fill';

    case 'LineLayer':
      return 'tileline';

    case 'PointLayer':
      return 'circle';

    case 'RasterLayer':
      return 'image';

    default:
      return '';
  }
}
export function getMaskValue(layerType, mask) {
  switch (layerType) {
    case 'PolygonLayer':
      return true;

    case 'LineLayer':
      return true;

    case 'PointLayer':
      return false;

    case 'RasterLayer':
      return mask;

    default:
      return mask;
  }
}
export function getContainerSize(container) {
  if (container.getContext) {
    return {
      width: container.width / DOM.DPR,
      height: container.height / DOM.DPR
    };
  } else {
    return container.getBoundingClientRect();
  }
}
export function isTileLoaded(tile) {
  return tile.layerIDList.length === tile.loadedLayers;
}
export function isTileChildLoaded(tile) {
  var children = tile.children;
  return children.filter(function (child) {
    return isTileLoaded(child);
  }).length === children.length;
}
export function isTileParentLoaded(tile) {
  var parent = tile.parent;

  if (!parent) {
    return true;
  } else {
    return isTileLoaded(parent);
  }
}
export function tileAllLoad(tile, callback) {
  var timer = window.setInterval(function () {
    var tileLoaded = isTileLoaded(tile);
    var tileChildLoaded = isTileChildLoaded(tile);
    var tileParentLoaded = isTileParentLoaded(tile);

    if (tileLoaded && tileChildLoaded && tileParentLoaded) {
      callback();
      window.clearInterval(timer);
    }
  }, 36);
}

function dispatchTileVisibleChange(tile, callback) {
  if (tile.isVisible) {
    callback();
  } else {
    tileAllLoad(tile, function () {
      callback();
    });
  }
}

function updateImmediately(layers) {
  var immediately = true;
  layers.map(function (layer) {
    if (layer.type !== 'PointLayer') {
      immediately = false;
    }
  });
  return immediately;
}

export function updateTileVisible(tile, layers, layerService) {
  if (layers.length === 0) return;

  if (updateImmediately(layers)) {
    updateLayersConfig(layers, 'visible', tile.isVisible);
    layerService.reRender();
    return;
  }

  dispatchTileVisibleChange(tile, function () {
    updateLayersConfig(layers, 'visible', tile.isVisible);
    layerService.reRender();
  });
}